module.exports = __webpack_public_path__ + "static/media/REGLEMENT_PARRAINAGE.0108a124.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/utils/assets/pdf/REGLEMENT_PARRAINAGE.pdf
// module id = 660
// module chunks = 0